import { render, staticRenderFns } from "./BannersDestaque.vue?vue&type=template&id=bf676e18&scoped=true"
import script from "./BannersDestaque.vue?vue&type=script&lang=js"
export * from "./BannersDestaque.vue?vue&type=script&lang=js"
import style0 from "./BannersDestaque.vue?vue&type=style&index=0&id=bf676e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf676e18",
  null
  
)

export default component.exports